import {
  createStore as createReduxStore,
  applyMiddleware,
  combineReducers
} from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import hardSet from "redux-persist/lib/stateReconciler/hardSet";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
  stateReconciler: hardSet
};

export const stores = [];

export function createStore(isDfd) {
  let reducer;

  if (isDfd) {
    reducer = combineReducers({ tdFlow: rootReducer });
  } else {
    reducer = persistReducer(
      persistConfig,
      combineReducers({ tdFlow: rootReducer })
    );
  }

  const reduxStore = createReduxStore(
    reducer,
    composeWithDevTools(applyMiddleware(thunk))
  );

  const store = {
    store: reduxStore
  };

  if (!isDfd) {
    store.persistor = persistStore(reduxStore);
  }

  stores.push(store);

  return store;
}

export function deleteStore(store) {
  const storeIndex = stores.indexOf(store);

  if (storeIndex >= 0) {
    stores.splice(storeIndex, 1);
  }
}
